<template>
  <div class="row">
    <div class="col-sm-12 pb-4" :class="gridLeft">
      <img v-if="leftImage" class="img-fluid" :src='leftImage' alt="Survey Left Logo">
    </div>
    <div class="col-sm-12 text-center align-middle" :class="gridCenter">
      <h1>{{ title }}</h1>
    </div>
    <div class="col-sm-12 pb-4 text-right" :class="gridRight">
      <img v-if="rightImage" class="img-fluid" :src='rightImage' alt="Survey Right Logo">
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      title: {
        type: String,
        default: 'HSP Survey'
      },
      displayOptions: {
        type: Array,
        default: function() {
          return [];
        }
      }
    },
    data() {
      return {
        imageDirectory: 'uploads/',
        headerLayouts: {
          half: [6,6],
          halfLeft: [4,8],
          halfRight: [8,4],
          thirds: [4,4,4],
          thirdCenterSmall: [3,6,3],
          thirdCenterMedium: [2,8,2],
          thirdCenterLarge: [1,10,1]
        }
      }
    },
    computed: {
      layout() {
        if(this.displayOptions.length > 0) {
          let layoutOption = this.displayOptions
            .find(displayOption => displayOption.optionId === this.displayTypeOptions.HEADER_LAYOUT)

          if(layoutOption) {
            return this.headerLayouts[layoutOption.optionValue];
          }
        }

        return null;
      },
      gridLeft() {
        if(this.layout) {
          return `col-md-${this.layout[0]}`;
        }

        return 'd-none';
      },
      gridCenter() {
        if(this.layout) {
          return `col-md-${this.layout[1]}`;
        }

        return '';
      },
      gridRight() {
        if(this.layout && this.layout.length > 2) {
          return `col-md-${this.layout[2]}`;
        }

        return 'd-none';
      },
      leftImage() {
        if(this.displayOptions.length > 0) {
          let layoutOption = this.displayOptions
            .find(displayOption => displayOption.optionId === this.displayTypeOptions.HEADER_LEFT_IMAGE)

          if(layoutOption) {
            return `${this.imageDirectory}${layoutOption.optionValue}`;
          }
        }

        return null;
      },
      rightImage() {
        if(this.displayOptions.length > 0) {
          let layoutOption = this.displayOptions
            .find(displayOption => displayOption.optionId === this.displayTypeOptions.HEADER_RIGHT_IMAGE)

          if(layoutOption) {
            return `${this.imageDirectory}${layoutOption.optionValue}`;
          }
        }

        return null;
      },
      ...mapGetters ([
        'displayTypeOptions'
      ])
    }
  }
</script>
